import { type ReactNode, type Ref } from "react";

import { type TableVirtualization } from "../Table.types";

interface TableVirtualizationWrapperProps {
  ref?: Ref<HTMLDivElement>;
  children: ReactNode;
  minWidth?: string;
  maxHeight?: TableVirtualization["maxHeight"];
  hasVirtualization: boolean;
}

export const TableVirtualizationWrapper = ({
  ref,
  children,
  minWidth,
  maxHeight = "400px",
  hasVirtualization,
}: TableVirtualizationWrapperProps) => {
  if (!hasVirtualization) return children;

  return (
    <div
      ref={ref}
      className="ui:overflow-x-hidden ui:overflow-y-auto"
      style={{
        minWidth,
        maxHeight,
      }}
    >
      {children}
    </div>
  );
};
